import { render, staticRenderFns } from "./icon-close-panel.vue?vue&type=template&id=6009e5cc&"
import script from "./icon-close-panel.vue?vue&type=script&lang=js&"
export * from "./icon-close-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports